/**
 * 判断是否为空
 * @param {*} value
 * @returns {boolean}
 */
export function isEmpty(value) {
  if (value === null || value === '' || value === undefined) {
    return true;
  }
  return false;
}

/**
 * CNPJ 清洗+格式化工具
 * @param val 输入原始值
 * @returns 格式化后的CNPJ字符串
 */
export function formatCnpj(val) {
  // 1. 只移除特殊符号，保留字母+数字（大小写都允许）
  let cleaned = String(val).replace(/[^A-Za-z0-9]/g, '');
  cleaned = cleaned.toUpperCase();
  // 2. 限制最大有效字符14位
  if (cleaned.length > 14) {
    cleaned = cleaned.substring(0, 14);
  }

  const len = cleaned.length;
  let formatted = '';

  // 分段拼接格式化
  if (len <= 2) {
    formatted = cleaned;
  } else if (len <= 5) {
    formatted = `${cleaned.slice(0, 2)}.${cleaned.slice(2)}`;
  } else if (len <= 8) {
    formatted = `${cleaned.slice(0, 2)}.${cleaned.slice(2, 5)}.${cleaned.slice(5)}`;
  } else if (len <= 12) {
    formatted = `${cleaned.slice(0, 2)}.${cleaned.slice(2, 5)}.${cleaned.slice(
      5,
      8
    )}/${cleaned.slice(8)}`;
  } else {
    formatted = `${cleaned.slice(0, 2)}.${cleaned.slice(2, 5)}.${cleaned.slice(
      5,
      8
    )}/${cleaned.slice(8, 12)}-${cleaned.slice(12, 14)}`;
  }

  return formatted;
}

// 下单的限制
export function orderCNPJ(val) {
  // 1. 清洗：只保留字母数字，统一大写
  const raw = String(val)
    .replace(/[^A-Za-z0-9]/g, '')
    .toUpperCase();

  // 自动区分 CPF(最大11) / CNPJ(最大14)
  const maxLen = raw.length <= 11 ? 11 : 14;
  const cleaned = raw.slice(0, maxLen);
  const len = cleaned.length;

  // CPF 格式化分支：000.000.000-00
  if (maxLen === 11) {
    if (len <= 3) return cleaned;
    if (len <= 6) return `${cleaned.slice(0, 3)}.${cleaned.slice(3)}`;
    if (len <= 9) return `${cleaned.slice(0, 3)}.${cleaned.slice(3, 6)}.${cleaned.slice(6)}`;
    return `${cleaned.slice(0, 3)}.${cleaned.slice(3, 6)}.${cleaned.slice(6, 9)}-${cleaned.slice(
      9
    )}`;
  }

  // CNPJ 格式化分支：AA.AAA.AAA/AAAA-99
  if (len <= 2) return cleaned;
  if (len <= 5) return `${cleaned.slice(0, 2)}.${cleaned.slice(2)}`;
  if (len <= 8) return `${cleaned.slice(0, 2)}.${cleaned.slice(2, 5)}.${cleaned.slice(5)}`;
  if (len <= 12) {
    return `${cleaned.slice(0, 2)}.${cleaned.slice(2, 5)}.${cleaned.slice(5, 8)}/${cleaned.slice(
      8
    )}`;
  }
  return `${cleaned.slice(0, 2)}.${cleaned.slice(2, 5)}.${cleaned.slice(5, 8)}/${cleaned.slice(
    8,
    12
  )}-${cleaned.slice(12, 14)}`;
}

export function formatCPF(val) {
  // 1. 清洗：只保留字母数字，统一大写
  const raw = String(val)
    .replace(/[^A-Za-z0-9]/g, '')
    .toUpperCase();

  // 2. 强制限制最大长度为 11
  const cleaned = raw.slice(0, 11);
  const len = cleaned.length;

  // 3. CPF 格式化分支：000.000.000-00
  if (len <= 3) return cleaned;
  if (len <= 6) return `${cleaned.slice(0, 3)}.${cleaned.slice(3)}`;
  if (len <= 9) return `${cleaned.slice(0, 3)}.${cleaned.slice(3, 6)}.${cleaned.slice(6)}`;

  return `${cleaned.slice(0, 3)}.${cleaned.slice(3, 6)}.${cleaned.slice(6, 9)}-${cleaned.slice(9)}`;
}
